// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__sTTIM","error-text":"Checkbox_error-text__RAu5I"};